import "../Stylesheet/Contact.css";
import { FiMail } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { LuSend } from "react-icons/lu";
import { FaLinkedinIn, FaGithub, FaInstagram, FaTwitter } from "react-icons/fa";
import { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";
import { FaArrowUp } from "react-icons/fa";

export default function Contact() {

  const { t } = useContext(LanguageContext);
  const c = t.contact;

  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowArrow(true);
      } else {
        setShowArrow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <section className="contact">
        {/* HEADER */}
        <div className="contact-header">
          <h1>{c.title}</h1>
          <p>{c.subtitle}</p>
        </div>

        {/* MAIN CONTENT */}
        <div className="contact-body">
          {/* LEFT SIDE */}
          <div className="contact-left">
            {/* CONTACT DETAILS */}
            <div className="contact-card">
              <h2>{c.detailsTitle}</h2>

              <div className="contact-item">
                <div className="icon blue">
                  <FiMail />
                </div>
                <div className="text">
                  <h4>{c.email}</h4>
                  <span>hello@alexmorgan.dev</span>
                </div>
              </div>

              <div className="contact-item">
                <div className="icon green">
                  <FaWhatsapp />
                </div>
                <div className="text">
                  <h4>{c.whatsapp}</h4>
                  <span>+1 (234) 567-890</span>
                </div>
              </div>

              <div className="contact-item">
                <div className="icon purple">
                  <IoLocationOutline />
                </div>
                <div className="text">
                  <h4>{c.location}</h4>
                  <span>{c.place}</span>
                </div>
              </div>
            </div>

            {/* CONNECT */}
            <div className="contact-card">
              <h2>{c.connectTitle}</h2>
              <div className="socials">
                <div className="social blue"><FaLinkedinIn /></div>
                <div className="social gray"><FaGithub /></div>
                <div className="social pink"><FaInstagram /></div>
                <div className="social sky"><FaTwitter /></div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="contact-right">
            <h2>{c.messageTitle}</h2>

            <div className="form">
              <form className="form">
                <label>{c.nameLabel}</label>
                <input type="text" placeholder={c.namePlaceholder} />

                <label>{c.emailLabel}</label>
                <input type="email" placeholder={c.emailPlaceholder} />

                <label>{c.messageLabel}</label>
                <textarea placeholder={c.messagePlaceholder}></textarea>

                <button className="Con-btn">
                  <LuSend /> {c.sendBtn}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      {showArrow && (
        <div className="scroll-top-arrow" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}

    </>
  );
}
